import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the InvoiceServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InvoiceServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Get Parameter
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-25
     */
    sendEmailInvoice(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Invoices/sendEmailInvoice', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/invoice-service/invoice-service.ts